import envDetect from '@tcc/env-detect';
import { queryStringToObject } from '../utils/transform';

// @TODO Add this from the Versions.json or Package.json
// For Experiments, this needs to be the same name used in
// @code scripts/exp_deploy.sh
const APP_NAME = 'auth-pages';

/**
 * Expose the global envDetect values to the app props
 * @param {App} app
 * @return {Promise}
 */
export default function setup(app) {
  app.setProps({
    name: APP_NAME,
    rootUrl: `https://${envDetect.getEnvHostname(envDetect.getCurrentEnv())}`,
    serviceUrl: envDetect.getServiceHostname(),
    href: window.location.href,
    env: envDetect.getCurrentEnv(),
    queryParams: queryStringToObject(window.location.search)
  });
  return Promise.resolve(true);
}
